// extracted by mini-css-extract-plugin
export var buttons = "StockTransferEditVenue-module--buttons--woUrw";
export var container = "StockTransferEditVenue-module--container--1fyJM";
export var form = "StockTransferEditVenue-module--form--dB6E5";
export var thumbnail = "StockTransferEditVenue-module--thumbnail--+yaVc";
export var thumbnailBadge = "StockTransferEditVenue-module--thumbnailBadge--fN7jf";
export var thumbnailWrapper = "StockTransferEditVenue-module--thumbnailWrapper--MQjOa";
export var welcomeContent = "StockTransferEditVenue-module--welcomeContent--K1HrW";